export default __webpack_public_path__ + "static/virtual-care-visit-ba4b1383f8639335835d10836493a9f8.png";